import { render, staticRenderFns } from "./addProductCategory.vue?vue&type=template&id=4cbbcc44"
import script from "./addProductCategory.vue?vue&type=script&lang=js"
export * from "./addProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports